





































import Component, { mixins } from "vue-class-component";
import axios from "@/plugins/axios";
import ErrorMixin from "@/mixins/errorMixins";

@Component({
  components: {},
})
export default class Adoria extends mixins(ErrorMixin) {
  public dates = [
    new Date().toISOString().substr(0, 10),
    new Date().toISOString().substr(0, 10),
  ];

  public DoExport() {
    this.$store.dispatch("login/setLoading", true);

    if (this.dates[0] > this.dates[1]) {
      const temp = this.dates[0];
      this.dates[0] = this.dates[1];
      this.dates[1] = temp;
    }

    const startDate = new Date(this.dates[0]);
    const exportDates = [];

    if (this.dates.length > 1 && this.dates[1] !== this.dates[0]) {
      const endDate = new Date(this.dates[1]);
      const dateToExport = new Date(startDate);

      while (dateToExport <= endDate) {
        exportDates.push(dateToExport.toISOString().substr(0, 10));
        dateToExport.setDate(dateToExport.getDate() + 1);
      }
    } else {
      exportDates.push(startDate.toISOString().substr(0, 10));
    }

    const promises = exportDates.map((date) => {
      const url = "adoria/exportDetailsVente?dateFiscale=" + date;
      return axios.get(url);
    });

    Promise.all(promises)
      .then((responses) => {
        responses.forEach((response: any) => {
          if (response.data.code === 2) {
            this.setSuccess(this.$t("exportOk").toString());
          } else {
            console.log(response.data.response);

            if (
              Array.isArray(response.data.response) &&
              response.data.response.length > 0 &&
              "message" in response.data.response[0]
            ) {
              response.data.response.forEach((item: any) => {
                if (item.message) {
                  this.setErrorsFromTxt(item.message.toString());
                } else {
                  this.setErrorsFromTxt(item.toString());
                }
              });
            } else if (
              response.data.response &&
              typeof response.data.response === "object" &&
              "message" in response.data.response
            ) {
              const err = response.data.response.message
                ? response.data.response.message.toString()
                : response.data.response.toString();
              this.setErrorFromTxt(err);
            } else {
              const err = response.data.response.toString();
              this.setErrorFromTxt(err);
            }
          }
        });

        this.$store.dispatch("login/setLoading", false);
      })
      .catch((error) => {
        console.log(error);
        this.setErrorFromTxt(error.toString());
        this.$store.dispatch("login/setLoading", false);
      });
  }
}
